import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getApplications } from 'services/CustomerService'
import { API_PAGINATION_LIMIT, API_PAGINATION_OFFSET } from 'utils/pagination'

interface UseGetApplicationsQueryParams {
  page?: number
  size?: number
  name?: string
  statuses?: string[]
  types?: string[]
  useCases?: string[]
  enabled?: boolean
}

export const useGetApplicationsQuery = ({
  page = API_PAGINATION_OFFSET,
  size = API_PAGINATION_LIMIT,
  name,
  statuses,
  types,
  useCases,
  enabled = true,
}: UseGetApplicationsQueryParams = {}) => {
  return useQuery({
    queryKey: reactQueryKeys.applications(page, size, name, statuses, types, useCases),
    queryFn: () => getApplications({ page, size, name, statuses, types, useCases }),
    enabled,
  })
}
